<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-comm" />
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
// 2021.12.07 SPKA-304 svg icon
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    IconSvg,
  },
  props: {
    btnTxt: {
      default: '',
    },
    btnIcon: {
      default: '',
    },
    dataValue: {
      default: Object,
    },
    comId: {
      default: '',
    },
    noteId: {
      default: '',
    },
    prnrId: {
      default: '',
    },
    dirCd: {
      default: '',
    },
    comTp: {
      default: 'COM',
    },
    isHistory: {
      default: false,
    },
    protocolList: {
      default: Array,
    },
    manage: {
      default: false,
    },
  },

  data() {
    return {
      procIconSize: 24,
      showClose: false,
      formData: {
        id: '',
        type: '',
        name: '',
        host: '',
        port: '1234',
        userid: '',
        password: '',
        security: '',
        interval: '30',
        email: '',
        path: '',
        fileNmPttn: '',
        comm_mq_nm: '',
        comm_mq_mgr: '',
        intervalType: 'MM',
        authToken: '',
      },
      nodeId: '',
      formEmit: {
        comTp: 'COM',
        comId: '',
        nodeId: '',
      },
    };
  },

  watch: {
    comId() {
      return this.comId;
    },
  },

  created() {
    this.initialize();
    EventBus.$on('change-component-data', this.changeComponentData);
  },

  mounted() {},
  methods: {
    resetForm() {
      this.formData = {
        id: '',
        type: '',
        name: '',
        host: '',
        port: '1234',
        userid: '',
        password: '',
        security: '',
        interval: '30',
        email: '',
        path: '',
        fileNmPttn: '',
        comm_mq_nm: '',
        comm_mq_mgr: '',
        intervalType: 'MM',
      };
      this.formEmit = {
        comId: '',
        nodeId: this.nodeId,
        comName: '',
        comTp: 'COM',
      };
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.formData.id = id;
        if (!this.formData.id) {
          this.resetForm();
          return;
        }
        this.selectComm();
      }
    },
    openRightLayer() {
      if (this.manage || this.isHistory) {
        EventBus.$emit('open-right-layer', this.formEmit);
      }
    },
    initialize() {
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        this.formData.id = this.comId;
        if (this.formData.id !== '') {
          this.selectComm();
        } else {
          this.formEmit = {
            comId: '',
            nodeId: this.nodeId,
            comName: '',
            comTp: this.comTp,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
    selectComm() {
      let index = this.communicationList.findIndex((e) => e.id == this.formData.id);
      if (index > -1 && (this.manage || this.isHistory)) {
        this.formData = Object.assign({}, this.communicationList[index]);
        this.formEmit = {
          comId: this.formData.id,
          nodeId: this.nodeId,
          comName: this.formData.name,
          comTp: this.comTp,
        };
        EventBus.$emit('set-comp-id', this.formEmit);
      } else {
        this.resetForm();
      }
    },
    close() {
      EventBus.$emit('close', this.nodeId);
    },
  },

  computed: {
    communicationList() {
      return this.$store.getters.communicationSelectBoxList;
    },
  },
};
</script>
